export default __webpack_public_path__ + "static/media/Vote.1e560460.png";